//----- audio js

const audio = document.getElementById("audioPlayer");
const volume = document.getElementById("volume");
const volVal = document.getElementById("volVal");

function updateVolume() {

  const percent = volume.value * 100;

  /* audio volume change */
  audio.volume = volume.value;

  /* text percentage */
  volVal.textContent = Math.round(percent) + "%";

  /* slider background */
  volume.style.background = `linear-gradient(
    to right,
    #EACB74 ${percent}%,
    rgba(255,255,255,.4) ${percent}%
  )`;

}

/* slider move event */
volume.addEventListener("input", updateVolume);

/* default volume load */
updateVolume();
document.addEventListener("DOMContentLoaded", function () {
 
  const audio = document.getElementById("audioPlayer");
  const cards = document.querySelectorAll(".hm_audio_card");
  const categorySections = document.querySelectorAll(
    ".hm_audio_itms [data-category]",
  );
  const buttons = document.querySelectorAll(".hm_audio_lbry_btn");

  const playerImage = document.getElementById("playerImage");
  const playerTitle = document.getElementById("playerTitle");
  const playerSubtitle = document.getElementById("playerSubtitle");
  const playerDesc = document.getElementById("playerDesc");
  const playPauseBtn = document.getElementById("playPauseBtn");
  const playPauseIcon = document.getElementById("playPauseIcon");
  const nowPlayingBox = document.querySelector(".now-playing");

  const progressBar = document.getElementById("progressBar");
  const currentTimeEl = document.getElementById("currentTime");
  const totalTimeEl = document.getElementById("totalTime");

  let currentCard = null;

  function showPlayIcon() {
    if (!playPauseIcon) return;
    playPauseIcon.style.maskImage =
      "url('https://cdn.shopify.com/s/files/1/0781/2451/5587/files/playPause.svg?v=1767778666')";
    playPauseIcon.style.webkitMaskImage =
      "url('https://cdn.shopify.com/s/files/1/0781/2451/5587/files/playPause.svg?v=1767778666')";
  }

  function showPauseIcon() {
    if (!playPauseIcon) return;
    playPauseIcon.style.maskImage =
      "url('https://cdn.shopify.com/s/files/1/0781/2451/5587/files/pause.svg?v=1767785495')";
    playPauseIcon.style.webkitMaskImage =
      "url('https://cdn.shopify.com/s/files/1/0781/2451/5587/files/pause.svg?v=1767785495')";
  }
  function loadDefaultAudio() {
    if (!cards.length) return;

    const firstCard = cards[0];

    const src = firstCard.dataset.audio;
    const title = firstCard.dataset.title;
    const img = firstCard.querySelector("img")?.src;
    const subtitle = firstCard.querySelector(".hm_audio_card_bdy p")?.textContent;
    const desc = firstCard.querySelector(".hm_audio_card_bdy span")?.textContent;

    // ✅ load audio but DO NOT autoplay
    audio.src = src;

    if (playerImage && img) {
      playerImage.style.backgroundImage = `url(${img})`;
      playerImage.classList.add("has-image");
    }

    playerTitle.textContent = title || "Audio Title";
    playerSubtitle.textContent = subtitle || "";
    playerDesc.textContent = desc || "";

    // play icon show (kyunki abhi play nahi hua)
    showPlayIcon();

    currentCard = firstCard;
  }
  cards.forEach((card) => {
    card.addEventListener("click", () => {
      const src = card.dataset.audio;
      const title = card.dataset.title;
      const img = card.querySelector("img")?.src;
      const subtitle = card.querySelector(".hm_audio_card_bdy p")?.textContent;
      const desc = card.querySelector(".hm_audio_card_bdy span")?.textContent;

      // ✅ SAME CARD CLICKED AGAIN
      if (currentCard === card) {
        if (audio.paused) {
          audio.play();
          showPauseIcon();
          nowPlayingBox?.classList.add("playing");
          card.classList.add("playing");
        } else {
          audio.pause();
          showPlayIcon();
          nowPlayingBox?.classList.remove("playing");
          card.classList.remove("playing");
        }

        return;
      }

      // ✅ NEW CARD CLICKED
      cards.forEach((c) => c.classList.remove("playing"));

      audio.src = src;
      audio.play();

      if (playerImage && img) {
        playerImage.style.backgroundImage = `url(${img})`;
        playerImage.classList.add("has-image");
      }

      if (playerTitle) playerTitle.textContent = title;
      if (playerSubtitle) playerSubtitle.textContent = subtitle;
      if (playerDesc) playerDesc.textContent = desc;

      showPauseIcon();
      card.classList.add("playing");
      nowPlayingBox?.classList.add("playing");

      currentCard = card;
    });
  });
  playPauseBtn?.addEventListener("click", () => {
    if (!audio.src) return;

    if (audio.paused) {
      audio.play();
      showPauseIcon();
      nowPlayingBox?.classList.add("playing");
      currentCard?.classList.add("playing");
    } else {
      audio.pause();
      showPlayIcon();
      nowPlayingBox?.classList.remove("playing");
      currentCard?.classList.remove("playing");
    }
  });
  const nextBtn = document.getElementById("nextBtn");
  const prevBtn = document.getElementById("prevBtn");

  // ⏭ NEXT → +10 sec
  nextBtn?.addEventListener("click", () => {
    if (!audio.duration) return;

    audio.currentTime = Math.min(audio.currentTime + 10, audio.duration);
  });

  // ⏮ PREVIOUS → -10 sec
  prevBtn?.addEventListener("click", () => {
    audio.currentTime = Math.max(audio.currentTime - 10, 0);
  });

  const progressContainer = document.querySelector(".progress");
  let isDragging = false;

  // 🔥 Common function (reuse everywhere)
  function updateSeek(clientX) {
    const rect = progressContainer.getBoundingClientRect();
    const x = clientX - rect.left;

    const percent = Math.min(Math.max(x / rect.width, 0), 1);
    audio.currentTime = percent * audio.duration;
  }

  progressContainer?.addEventListener("click", (e) => {
    if (!audio.duration) return;
    updateSeek(e.clientX);
  });

  // Drag start
  progressContainer?.addEventListener("mousedown", (e) => {
    isDragging = true;
    updateSeek(e.clientX);
  });

  // Drag move
  document.addEventListener("mousemove", (e) => {
    if (!isDragging || !audio.duration) return;
    updateSeek(e.clientX);
  });

  // Drag end
  document.addEventListener("mouseup", () => {
    isDragging = false;
  });


  // Touch start
  progressContainer?.addEventListener("touchstart", (e) => {
    isDragging = true;
    updateSeek(e.touches[0].clientX);
  });

  // Touch move
  progressContainer?.addEventListener("touchmove", (e) => {
    if (!isDragging || !audio.duration) return;

    updateSeek(e.touches[0].clientX);
  });

  // Touch end
  progressContainer?.addEventListener("touchend", () => {
    isDragging = false;
  });
  const progressThumb = document.getElementById("progressThumb");

  audio?.addEventListener("timeupdate", () => {
    if (!audio.duration) return;

    const percent = (audio.currentTime / audio.duration) * 100;

    // bar update
    if (progressBar) progressBar.style.width = percent + "%";

    // 🔥 thumb move
    if (progressThumb) progressThumb.style.left = percent + "%";

    // time update (tumhara existing code)
  });

  audio?.addEventListener("timeupdate", () => {
    if (!audio.duration) return;

    const percent = (audio.currentTime / audio.duration) * 100;
    if (progressBar) progressBar.style.width = percent + "%";

    if (currentTimeEl) {
      currentTimeEl.textContent =
        Math.floor(audio.currentTime / 60) +
        ":" +
        Math.floor(audio.currentTime % 60)
          .toString()
          .padStart(2, "0");
    }

    if (totalTimeEl) {
      totalTimeEl.textContent =
        Math.floor(audio.duration / 60) +
        ":" +
        Math.floor(audio.duration % 60)
          .toString()
          .padStart(2, "0");
    }
  });

  audio?.addEventListener("ended", () => {
    showPlayIcon();
    nowPlayingBox?.classList.remove("playing");
    currentCard?.classList.remove("playing");
  });
 loadDefaultAudio();

  // });
  /* DEFAULT PAGE LOAD → MANTRA SHOW */

  categorySections.forEach((section) => {
    section.style.display = section.dataset.category === "Chakra" ? "" : "none";
  });

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      buttons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      const filter = btn.dataset.filter;
      categorySections.forEach((section) => {
        section.style.display =
          section.dataset.category === filter ? "" : "none";
      });
    });
  });

  const rashiTabs = document.querySelectorAll(".rashi_cmbo_list_lft-wrapper a");
  const rashiContents = document.querySelectorAll(".rashi_cmbo_list_rght li");

  rashiTabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      e.preventDefault();
      const target = tab.getAttribute("href");

      rashiTabs.forEach((t) => t.classList.remove("active"));
      rashiContents.forEach((c) => c.classList.remove("active"));

      tab.classList.add("active");
      document.querySelector(target)?.classList.add("active");
    });
  });

  document.querySelectorAll(".sptl_tab li").forEach((tab) => {
    tab.addEventListener("click", () => {
      const id = tab.dataset.tab;
      document
        .querySelectorAll(".sptl_tab li, .tab_cnt")
        .forEach((el) => el.classList.remove("current"));
      tab.classList.add("current");
      document.getElementById(id)?.classList.add("current");
    });
  });

  document.querySelectorAll(".likeHeart").forEach((heart) => {
    heart.addEventListener("click", () => heart.classList.toggle("active"));
  });

  document.querySelectorAll(".hm_faq_hrd").forEach((header) => {
    header.addEventListener("click", () => {
      const body = header.nextElementSibling;

      if (header.classList.contains("active")) {
        header.classList.remove("active");
        body.style.display = "none";
      } else {
        document
          .querySelectorAll(".hm_faq_hrd")
          .forEach((h) => h.classList.remove("active"));
        document
          .querySelectorAll(".hm_faq_bdy")
          .forEach((b) => (b.style.display = "none"));
        header.classList.add("active");
        body.style.display = "block";
      }
    });
  });
});

// if (typeof Swiper !== "undefined") {
//   new Swiper(".mySwiper", {
//     loop: true,
//     slidesPerView: 4,
//     spaceBetween: 20,
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//     breakpoints: {
//       1024: { slidesPerView: 4 },
//       768: { slidesPerView: 2 },
//       0: { slidesPerView: 2 },
//     },
//   });

//   // new Swiper(".mySwiper-prmum_sptl", {
//   //   loop: true,
//   //   slidesPerView: 3,
//   //   spaceBetween: 20,
//   //   navigation: {
//   //     nextEl: ".swiper-button-next",
//   //     prevEl: ".swiper-button-prev",
//   //   },
//   //   breakpoints: {
//   //     1024: { slidesPerView: 3 },
//   //     768: { slidesPerView: 2 },
//   //     0: { slidesPerView: 2 },
//   //   },
//   // });

//   // new Swiper(".hm_tstml_list", {
//   //   loop: true,
//   //   effect: "coverflow",
//   //   grabCursor: true,
//   //   slidesPerView: "auto",
//   //   centeredSlides: true,
//   //   coverflowEffect: {
//   //     rotate: 0,
//   //     stretch: 0,
//   //     depth: 100,
//   //     modifier: 3,
//   //     slideShadows: true,
//   //   },
//   //   //  autoplay: {
//   //   //     delay: 3000,
//   //   //     disableOnInteraction: false,
//   //   //   },
//   //   pagination: { el: ".swiper-pagination" },
//   //   navigation: {
//   //     nextEl: ".swiper-button-next",
//   //     prevEl: ".swiper-button-prev",
//   //   },
//   //   keyboard: {
//   //     enabled: true,
//   //   },
//   //   breakpoints: {
//   //     560: {
//   //       slidesPerView: 2.5,
//   //     },
//   //     768: {
//   //       slidesPerView: 3,
//   //     },
//   //     1024: {
//   //       slidesPerView: 3,
//   //     },
//   //   },
//   // });
// }
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".quick-add-btn").forEach(function (btn) {
    const productId = btn.getAttribute("data-product-id");
    const icon = btn.querySelector(".cart-icon");
    const success = btn.querySelector(".cart-success");

    if (!productId) return;

    if (localStorage.getItem("wishlist-" + productId)) {
      btn.classList.add("active");
      icon.style.display = "none";
      success.hidden = false;
    }

    btn.addEventListener("click", function () {
      if (btn.classList.contains("active")) {
        btn.classList.remove("active");
        localStorage.removeItem("wishlist-" + productId);
        success.hidden = true;
        icon.style.display = "block";
      } else {
        btn.classList.add("active");
        localStorage.setItem("wishlist-" + productId, "true");
        icon.style.display = "none";
        success.hidden = false;
      }
    });
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".toggle-cart-btn").forEach(function (btn) {
//     const variantId = btn.dataset.variantId;

//     fetch("/cart.js")
//       .then((res) => res.json())
//       .then((cart) => {
//         const item = cart.items.find((i) => i.variant_id == variantId);
//         if (item) {
//           btn.dataset.added = "true";
//           btn.innerText = "Add to cart";
//         }
//       });

//     btn.addEventListener("click", function () {
//       const isAdded = btn.dataset.added === "true";
//       btn.innerText = isAdded ? "Removing..." : "Adding...";

//       fetch(isAdded ? "/cart/change.js" : "/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(
//           isAdded
//             ? { id: variantId, quantity: 0 }
//             : { id: variantId, quantity: 1 },
//         ),
//       })
//         .then((res) => res.json())
//         .then(() => {
//           btn.dataset.added = (!isAdded).toString();
//           btn.innerText = isAdded ? "Add to cart" : "Add to cart";

//           document.dispatchEvent(new CustomEvent("cart:refresh"));
//         });
//     });
//   });
// });
// document.addEventListener("DOMContentLoaded", async function () {

//   const buttons = document.querySelectorAll(".toggle-cart-btn");

//   if (!buttons.length) return;

//   // Sirf ek baar cart fetch
//   const cart = await fetch("/cart.js").then(res => res.json());

//   buttons.forEach(function (btn) {

//     const variantId = btn.dataset.variantId;

//     const item = cart.items.find(
//       i => String(i.variant_id) === String(variantId)
//     );

//     if (item) {
//       btn.dataset.added = "true";
//       btn.innerText = "Added";
//     }

//     btn.addEventListener("click", function () {

//       const isAdded = btn.dataset.added === "true";

//       btn.innerText = isAdded
//         ? "Removing..."
//         : "Adding...";

//       fetch(
//         isAdded
//           ? "/cart/change.js"
//           : "/cart/add.js",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json"
//           },
//           body: JSON.stringify(
//             isAdded
//               ? { id: variantId, quantity: 0 }
//               : { id: variantId, quantity: 1 }
//           )
//         }
//       )
//       .then(res => res.json())
//       .then(() => {

//         btn.dataset.added = (!isAdded).toString();

//         btn.innerText = !isAdded
//           ? "Added"
//           : "Add to Cart";

//         document.dispatchEvent(
//           new CustomEvent("cart:refresh")
//         );

//       });
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".pandit_hm_cltn li");

  items.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      items.forEach((i) => i.classList.remove("active"));
      item.classList.add("active");
    });
  });
});


document.addEventListener("click", function (e) {
  const heart = e.target.closest(".hrt_svg");
  if (!heart) return;

  const productId = heart.dataset.productId;
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  if (wishlist.includes(productId)) {
    wishlist = wishlist.filter((id) => id !== productId);
    heart.classList.remove("active");
  } else {
    wishlist.push(productId);
    heart.classList.add("active");
  }

  localStorage.setItem("wishlist", JSON.stringify(wishlist));
});

const zodiacItems = document.querySelectorAll(".pt-zodiac-item");
let hoverTimeout;
function activateZodiac(element) {
  zodiacItems.forEach((el) => el.classList.remove("active"));
  element.classList.add("active");

  document.querySelectorAll(".pt-product-tab").forEach((tab) => {
    tab.classList.remove("active");
  });

  const zodiac = element.getAttribute("data-zodiac");
  const targetTab = document.getElementById(zodiac);
  if (targetTab) {
    targetTab.classList.add("active");
  }
}
zodiacItems.forEach((item) => {
  item.addEventListener("click", function () {
    activateZodiac(this);
  });

});

// const events = {

//   "2026-03-01": {
//     title: "Ravi Pradosh Vrat",
//     details: "Pradosh fasting dedicated to Lord Shiva."
//   },

//   "2026-03-02": {
//     title: "Holika Dahan",
//     details: "A ritual bonfire celebrating the victory of good over evil."
//   },

//   "2026-03-04": {
//     title: "Holi",
//     details: "The vibrant 'Festival of Colors' celebrating spring, love, and new beginnings."
//   },

//   "2026-03-05": {
//     title: "Bhai Dooj, Bhratri Dwitiya",
//     details: "A celebration of the bond between siblings, where sisters pray for their brothers' long lives."
//   },

//   "2026-03-06": {
//     title: "Bhalachandra Sankashti Chaturthi",
//     details: "A monthly fast dedicated to Lord Ganesha to seek his blessings and remove obstacles."
//   },

//   "2026-03-08": {
//     title: "Rang Panchami",
//     details: "A vibrant color festival celebrated five days after Holi to mark the victory over negative energies."
//   },

//   "2026-03-10": {
//     title: "Sheetala Saptami",
//     details: "Day dedicated to Goddess Sheetala for protection from diseases."
//   },

//   "2026-03-11": [
//     {
//       title: "Sheetala Ashtami",
//       details: "Worship of Goddess Sheetala."
//     },
//     {
//       title: "Kalashtami",
//       details: "Worship of Lord Kaal Bhairav."
//     }
//   ],

//   "2026-03-15": [
//     {
//       title: "Papmochini Ekadashi",
//       details: "Ekadashi fast believed to cleanse sins and negative karma."
//     },
//     {
//       title: "Meena Sankranti",
//       details: "Sun enters Pisces (Meena Rashi) marking a solar transition."
//     }
//   ],

//   "2026-03-16": {
//     title: "Som Pradosh Vrat",
//     details: "Monday Pradosh fast dedicated to Lord Shiva."
//   },

//   "2026-03-17": {
//     title: "Masik Shivratri",
//     details: "Monthly Shivratri fasting and night worship of Lord Shiva."
//   },

//   "2026-03-18": {
//     title: "Darsha Amavasya",
//     details: "New moon day for ancestral prayers and spiritual practices."
//   },

//   "2026-03-19": {
//     title: "Chaitra Amavasya",
//     details: "Important Amavasya marking transition into the new lunar cycle."
//   },

//   "2026-03-20": {
//     title: "Chaitra Navratri Begins / Ugadi / Gudi Padwa",
//     details: "Start of Hindu New Year and nine-day Navratri festival."
//   },

//   "2026-03-21": {
//     title: "Matsya Jayanti",
//     details: "Birth anniversary of Lord Vishnu’s Matsya avatar."
//   },

//   "2026-03-22": {
//     title: "Vinayaka Chaturthi",
//     details: "Monthly Chaturthi dedicated to Lord Ganesha."
//   },

//   "2026-03-23": {
//     title: "Lakshmi Panchami",
//     details: "Day dedicated to Goddess Lakshmi for prosperity."
//   },

//   "2026-03-24": {
//     title: "Yamuna Chhath / Skanda Shashti",
//     details: "Worship of Yamuna Devi and Lord Kartikeya."
//   },

//   "2026-03-26": {
//     title: "Durga Ashtami",
//     details: "Sacred Navratri day devoted to Goddess Durga."
//   },

//   "2026-03-27": {
//     title: "Ram Navami",
//     details: "Celebration of the birth of Lord Rama."
//   },

//   "2026-03-30": {
//     title: "Som Pradosh Vrat",
//     details: "Pradosh fasting observed on Monday for Lord Shiva."
//   },

//   "2026-03-31": {
//     title: "Mahavir Jayanti",
//     details: "Birth anniversary of Lord Mahavira, the 24th Tirthankara of Jainism."
//   },



//   "2026-04-01": {
//     title: "Anvadhan",
//     details: "A Vedic ritual of offering sacred fuel sticks to the fire before a yajna."
//   },

//   "2026-04-02": {
//     title: "Hanuman Jayanti / Chaitra Purnima",
//     details: "Birth anniversary of Lord Hanuman and the full moon of Chaitra month."
//   },

//   "2026-04-05": {
//     title: "Vikata Sankashti Chaturthi",
//     details: "Monthly Sankashti fast dedicated to Lord Ganesha."
//   },

//   "2026-04-10": {
//     title: "Kalashtmi",
//     details: "Monthly fast dedicated to Lord Bhairava."
//   },

//   "2026-04-13": {
//     title: "Varuthini Ekadashi",
//     details: "Sacred Ekadashi fasting believed to remove sins and grant protection."
//   },

//   "2026-04-14": [
//     {
//       title: "Mesha Sankranti / Solar New Year",
//       details: "Sun enters Aries marking the beginning of the Hindu Solar New Year."
//     },
//     {
//       title: "Puthandi",
//       details: "Tamil New Year marking the Sun’s entry into Aries."
//     },
//     {
//       title: "Baisakhi",
//       details: "Harvest festival marking the Sikh New Year."
//     },
//     {
//       title: "Vishu Kani",
//       details: "Auspicious first sight ritual marking the Malayalam New Year."
//     }
//   ],

//   "2026-04-15": {
//     title: "Budha Pradosh Vrat",
//     details: "Pradosh fast dedicated to Lord Shiva observed on Wednesday."
//   },

//   "2026-04-17": [
//     {
//       title: "Darsh Amavasya",
//       details: "New moon day observed with rituals for ancestors."
//     },
//     {
//       title: "Vaishakh Amavasya",
//       details: "New moon day of the Vaishakh month observed for ancestor rituals."
//     }
//   ],

//   "2026-04-18": {
//     title: "Ishti",
//     details: "A Vedic ritual offering performed after Amavasya."
//   },

//   "2026-04-19": [
//     {
//       title: "Parashurama Jayanti",
//       details: "Birth anniversary of Lord Vishnu’s sixth incarnation, Parashurama."
//     },
//     {
//       title: "Masik Karthigai",
//       details: "Monthly observance dedicated to Lord Murugan."
//     },
//     {
//       title: "Treta Yuga Divas",
//       details: "Day believed to mark the beginning of Treta Yuga."
//     }
//   ],

//   "2026-04-20": {
//     title: "Rohini Vrat",
//     details: "A fast observed when Rohini Nakshatra occurs."
//   },

//   "2026-04-21": {
//     title: "Shankracharya Jayanti",
//     details: "Birth anniversary of Adi Shankaracharya."
//   },

//   "2026-04-22": [
//     {
//       title: "Ramanuja Jayanti",
//       details: "Birth anniversary of philosopher Ramanujacharya."
//     },
//     {
//       title: "Skanda Sashti",
//       details: "Monthly fast dedicated to Lord Skanda (Kartikeya)."
//     }
//   ],

//   "2026-04-24": {
//     title: "Baglamukhi Jayanti",
//     details: "Birth anniversary of Goddess Baglamukhi."
//   },

//   "2026-04-25": {
//     title: "Sita Navmi",
//     details: "Birth anniversary of Goddess Sita."
//   },

//   "2026-04-27": [
//     {
//       title: "Mohini Ekadashi",
//       details: "Ekadashi dedicated to the Mohini avatar of Lord Vishnu."
//     },
//     {
//       title: "Sidhilakshmi Jayanti",
//       details: "Day dedicated to worship of Goddess Siddhilakshmi."
//     }
//   ],

//   "2026-04-28": {
//     title: "Bhaum Pradosh Vrat",
//     details: "Pradosh fast dedicated to Lord Shiva observed on Tuesday."
//   },

//   "2026-04-29": {
//     title: "Narasimha Jayanti",
//     details: "Birth anniversary of Lord Vishnu’s Narasimha avatar."
//   },

//   "2026-04-30": {
//     title: "Chinnamasta Jayanti",
//     details: "Birth anniversary of Goddess Chinnamasta."
//   }

// };

// // ================== ELEMENTS ==================
// const calendarDays = document.getElementById("calendarDays");
// const eventTitle = document.getElementById("eventTitle");
// const eventDetails = document.getElementById("eventDetails");

// const monthSelect = document.getElementById("monthSelect");
// const yearSelect = document.getElementById("yearSelect");


// // ================== EXTRACT MONTHS & YEARS ==================
// const uniqueMonths = new Set();
// const uniqueYears = new Set();

// Object.keys(events).forEach(date => {
//   const [year, month] = date.split("-");
//   uniqueYears.add(parseInt(year));
//   uniqueMonths.add(parseInt(month) - 1);
// });

// const allowedMonths = [...uniqueMonths].sort((a, b) => a - b);
// const allowedYears = [...uniqueYears];

// const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];


// // ================== DROPDOWN ==================
// allowedMonths.forEach(m => {
//   let opt = document.createElement("option");
//   opt.value = m;
//   opt.text = monthNames[m];
//   monthSelect.appendChild(opt);
// });

// allowedYears.forEach(y => {
//   let opt = document.createElement("option");
//   opt.value = y;
//   opt.text = y;
//   yearSelect.appendChild(opt);
// });


// // ================== DEFAULT ==================
// const today = new Date();
// const todayMonth = today.getMonth();
// const todayYear = today.getFullYear();

// // check if today's month exists in allowedMonths
// let index = allowedMonths.indexOf(todayMonth);

// if (index === -1) {
//   index = 0; // fallback agar data me month nahi hai
// }

// currentMonthIndex = index;
// currentDate = new Date(todayYear, allowedMonths[currentMonthIndex]);


// // ================== NAV BUTTON UPDATE ==================
// function updateNavButtons() {
//   document.getElementById("prevMonth").disabled = currentMonthIndex === 0;
//   document.getElementById("nextMonth").disabled = currentMonthIndex === allowedMonths.length - 1;
// }


// // ================== DATE FORMAT FUNCTION ==================
// function formatDate(dateKey) {
//   const dateObj = new Date(dateKey);

//   return dateObj.toLocaleDateString("en-IN", {
//     weekday: "long",
//     day: "numeric",
//     month: "long"
//   });
// }


// // ================== RENDER ==================
// function renderCalendar() {
//   calendarDays.innerHTML = "";

//   const year = currentDate.getFullYear();
//   const month = currentDate.getMonth();

//   monthSelect.value = month;
//   yearSelect.value = year;

//   updateNavButtons();

//   const today = new Date();

//   const todayKey = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

//   const firstDay = new Date(year, month, 1).getDay();
//   const totalDays = new Date(year, month + 1, 0).getDate();

//   eventTitle.innerText = "Events";

//   // ===== TODAY EVENT =====
//   if (events[todayKey]) {
//     eventDetails.innerHTML = "";
//     renderEvents(events[todayKey], todayKey);
//   } else {
//     eventDetails.innerText = "No vrat or fasting on this day";
//   }

//   // empty spaces
//   for (let i = 0; i < firstDay; i++) {
//     calendarDays.appendChild(document.createElement("div"));
//   }

//   // days loop
//   for (let day = 1; day <= totalDays; day++) {
//     const dateKey = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

//     const dayDiv = document.createElement("div");
//     dayDiv.classList.add("day");

//     const dayNumber = document.createElement("div");
//     dayNumber.classList.add("day-number");
//     dayNumber.innerText = day;

//     dayDiv.appendChild(dayNumber);

//     // ===== TODAY HIGHLIGHT =====
//     if (
//       day === today.getDate() &&
//       month === today.getMonth() &&
//       year === today.getFullYear()
//     ) {
//       dayDiv.classList.add("today");
//     }

//     // ===== EVENTS IN CALENDAR =====
//     if (events[dateKey]) {

//       if (Array.isArray(events[dateKey])) {
//         events[dateKey].forEach(ev => {
//           const eventName = document.createElement("div");
//           eventName.classList.add("event-name");
//           eventName.innerText = ev.title;
//           dayDiv.appendChild(eventName);
//         });
//       } else {
//         const eventName = document.createElement("div");
//         eventName.classList.add("event-name");
//         eventName.innerText = events[dateKey].title;
//         dayDiv.appendChild(eventName);
//       }

//       const dot = document.createElement("div");
//       dot.classList.add("event-dot");
//       dayDiv.appendChild(dot);
//     }

//     // ===== CLICK EVENT =====
//     dayDiv.addEventListener("click", () => {
//       eventTitle.innerText = "Events";

//       if (events[dateKey]) {
//         eventDetails.innerHTML = "";
//         renderEvents(events[dateKey], dateKey);
//       } else {
//         eventDetails.innerText = "No vrat or fasting on this day";
//       }

//       // SCROLL TO EVENT DETAILS
//       // eventDetails.scrollIntoView({
//       //   behavior: "smooth",
//       //   block: "start" 
//       // });
//     });

//     calendarDays.appendChild(dayDiv);
//   }
// }


// // ================== EVENT RENDER ==================
// function renderEvents(data, dateKey) {

//   const formattedDate = formatDate(dateKey);

//   if (Array.isArray(data)) {
//     data.forEach(ev => {
//       eventDetails.innerHTML += `
//         <div class="event-item">
//           <span class="event-date">${formattedDate}</span>
//           <h4>${ev.title}</h4>
//           <p>${ev.details}</p>
//         </div>
//       `;
//     });
//   } else {
//     eventDetails.innerHTML = `
//       <div class="event-item">
//         <span class="event-date">${formattedDate}</span>
//         <h4>${data.title}</h4>
//         <p>${data.details}</p>
//       </div>
//     `;
//   }
// }


// // ================== INIT ==================
// renderCalendar();


// // ================== DROPDOWN CHANGE ==================
// monthSelect.addEventListener("change", () => {
//   const selected = parseInt(monthSelect.value);
//   currentMonthIndex = allowedMonths.indexOf(selected);
//   currentDate.setMonth(selected);
//   renderCalendar();
// });

// yearSelect.addEventListener("change", () => {
//   currentDate.setFullYear(parseInt(yearSelect.value));
//   renderCalendar();
// });


// // ================== NAVIGATION ==================
// document.getElementById("nextMonth").onclick = () => {
//   if (currentMonthIndex < allowedMonths.length - 1) {
//     currentMonthIndex++;
//     currentDate.setMonth(allowedMonths[currentMonthIndex]);
//     renderCalendar();
//   }
// };

// document.getElementById("prevMonth").onclick = () => {
//   if (currentMonthIndex > 0) {
//     currentMonthIndex--;
//     currentDate.setMonth(allowedMonths[currentMonthIndex]);
//     renderCalendar();
//   }
// };